export enum ResponseErrorReason {
  Unauthorized = "ResponseErrorReason:Unauthorized",
}
